import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { useNavigate, useParams } from 'react-router-dom';
import { checkIfCollabratorExist, updateCollabratorPass, updateSelectedCollabratorToken } from '../../actions/collabratorAction';
import { useDispatch } from 'react-redux';
import { TOAST_SUCCESS } from '../../utils';
import { getUserInfo } from '../../actions/loginActions'; 
import LoadingScreen from '../CommonComponents/LoadingScreen';
import { MediaBaseUrl } from '../../actions/api';
import { FontAwesomeIcon } from '../CommonComponents/AssetsHelper';

let checkCollab = true;
function CollabratorConfirmAccount() {

    const [pass, setPass] = useState('')
    const [passError, setPassError] = useState(false);
    const [request, setRequest] = useState(true);
    const [passErrorMsg, setPassErrorMsg] = useState('');
    const [confirmpass, setconfirmpass] = useState('')
    const [confirmpassError, setconfirmpassError] = useState(false);
    const [confirmpassErrorMsg, setconfirmpassErrorMsg] = useState('');
    const [ownerId, setOwnerId] = useState();
    const [wallId, setWallId] = useState();
    const [loading, setLoading] = useState(false);
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const onClickToFinish = () => {
        setLoading(true);
        if ((pass !== '' && pass.length > 0) && (confirmpass !== '' && confirmpass.length > 0)) {

            if (pass === confirmpass) {
                dispatch(updateCollabratorPass(pass, ownerId, wallId, () => setLoading(false), navigate));
            } else {
                setLoading(false);
                setconfirmpassError(true);
                setconfirmpassErrorMsg('Password does not match');
            }

        } else {
            setLoading(false);
            if ((pass === '' || pass.length === 0) && (confirmpass === '' || confirmpass.length === 0)) {
                setPassError(true);
                setPassErrorMsg('Password cannot be empty');
                setconfirmpassError(true);
                setconfirmpassErrorMsg('Password cannot be empty');
            } else if (pass === '' || pass.length === 0) {
                setPassError(true);
                setPassErrorMsg('Password cannot be empty');
            } else {
                setconfirmpassError(true);
                setconfirmpassErrorMsg('Password cannot be empty');
            }
        }

    }

    const onInputChange = (e) => {
        setconfirmpass(e.target.value);
        setconfirmpassError(false);
    }

    const validatePassword = event => {
        var password = event.target.value;
        $('#register-submit-btn').attr('disabled', true);
        $('#popover-password').show();
        var strength = 0;

        if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            strength += 1;
            $('.low-upper-case').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.low-upper-case').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.match(/([0-9])/)) {
            strength += 1;
            $('.one-number').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.one-number').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
            strength += 1;
            $('.one-special-char').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.one-special-char').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.length > 7) {
            strength += 1;
            $('.eight-character').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.eight-character').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        // If value is less than 2
        if (strength == 0) {
            $('#result').removeClass()
            $('#password-strength').addClass('progress-bar-danger');
            $('#result').addClass('text-danger').text('');
            $('#password-strength').css('width', '0%');
        } else if (strength == 1) {
            $('#result').removeClass()
            $('#password-strength').removeClass('progress-bar-warning');
            $('#password-strength').addClass('progress-bar-danger');
            $('#result').addClass('text-danger').text('Weak');
            $('#password-strength').css('width', '10%');
        } else if (strength == 2 || strength == 3) {
            $('#result').addClass('good');
            $('#password-strength').removeClass('progress-bar-danger');
            $('#password-strength').removeClass('progress-bar-success');
            $('#password-strength').addClass('progress-bar-warning');
            $('#result').addClass('text-warning').text('Average')
            $('#password-strength').css('width', '60%');
        } else if (strength == 4) {
            $('#register-submit-btn').attr('disabled', false);
            $('#result').removeClass()
            $('#result').addClass('strong');
            $('#password-strength').removeClass('progress-bar-warning');
            $('#password-strength').removeClass('progress-bar-danger');
            $('#password-strength').addClass('progress-bar-success');
            $('#result').addClass('text-success').text('Strong');
            $('#password-strength').css('width', '100%');
        }
        setPass(password);
        setPassError(false);
    }
    const showPass = event => {
        var x = document.getElementById("AccountPassword");

        var element = document.getElementById("show_password_icon");
        element.classList.toggle("view_pass");

        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    useEffect(() => {
        setOwnerId(params.userId);
        setWallId(params.wallId);

        if(checkCollab){
            checkCollab = false;
            checkIfCollabratorExist(params.userId, params.wallId).then(response => {
                const { responseData, responseMessage } = response.data;
                if (responseData && Object.keys(responseData).length > 0) {
                    TOAST_SUCCESS(responseMessage);
                    if (responseData.token) {
                        localStorage.setItem('access_token', responseData.token);
                        const { user } = responseData;
    
    
                        if (user && Object.keys(user).length > 0) {
                            localStorage.setItem('ownerId', user.ownerId)    
                            // localStorage.setItem('loginOwnerId', user.id);
                            localStorage.setItem('loginOwnerId',user.userhashId)
                            localStorage.setItem('isCollaborator', 0);
                        }
                        dispatch(getUserInfo(navigate, false, false, true,(collabrator) => {
                            if (collabrator) {
                                dispatch(updateSelectedCollabratorToken(collabrator));
                                localStorage.setItem('isCollaborator', 1);
                                navigate(`/walls`);
                            }
                        }));
                    }
                }else{
                    setRequest(false);
                }
            }).catch(ex=>{
            const { data } = ex.response;
            const { responseMessage } = data;
            console.log(responseMessage,"responseMessage")
            })
        }
    }, [])
    return <>
        {request ? <LoadingScreen /> : <div className="loginFormSec registerFormSec formControlMin">
            <div className="loginWithSocials">
                <div className="loginHead">
                    <h2>Create Password</h2>
                    <p>Enter password for your Taggbox account here:</p>
                </div>
            </div>
            <div className="loginBlock">
                <div className="loginInnSec">
                    <div id="AccountOtherinfoForm">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group labelPosition">
                                    <label htmlFor="password">Password</label>
                                    <div className="password_wrap">
                                        <input name="data[Account][password]" className={`${passError ? `form-error` : ``} form-control placeholder-no-fix`} minlength="8" maxlength="256" onKeyUp={validatePassword} autoComplete={'off'} type="password" id="AccountPassword" aria-autocomplete="list" /> <button id="show_password_icon" type="button" className="show_password_icon" onClick={showPass} data-factors-form-bind="true" data-factors-click-bind="true">
                                            <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={'text-gray-500'} />
                                            <FontAwesomeIcon type={'regular'} icon={'eye-slash'} iconClass={'text-gray-500'} />
                                        </button>
                                    </div>
                                    {passError ? <span className="errorMessage">{passErrorMsg}</span> : null}
                                </div>
                                <div className="form-group labelPosition">
                                    <label htmlFor="password">Confirm Password</label>
                                    <input name="pass" className={`form-control placeholder-no-fix ${confirmpassError ? ` form-error` : ``}`} autoComplete={'off'} type="password" value={confirmpass} id="password" data-factors-input-id="form-0.field-0" onChange={onInputChange} />
                                    {confirmpassError ? <span className="errorMessage">{confirmpassErrorMsg}</span> : null}
                                </div>
                            </div>
                            <div id="popover-password" style={{ display: 'none' }}>
                                <p style={{ textAlign: 'left' }}>Strength: <span id="result"></span></p>
                                <div className="progress">
                                    <div id="password-strength" className="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style={{ width: '0%' }}>
                                    </div>
                                </div>
                                <ul className="list-unstyled verified_checkpoints">
                                    <li><span className="low-upper-case">
                                        <i className="point_ver__"></i>
                                    </span>Upper Case & Lower Case Alphabets (A-z)</li>
                                    <li><span className="one-number">
                                        <i className="point_ver__"></i>
                                    </span>1 Number (0-9)</li>
                                    <li><span className="one-special-char">
                                        <i className="point_ver__"></i>
                                    </span>1 Special symbol (!@#$&*)</li>
                                    <li><span className="eight-character">
                                        <i className="point_ver__"></i>
                                    </span>Minimum 8 Characters</li>
                                </ul>
                            </div>
                            <div className="col-sm-12">
                                <div style={{ clear: 'both' }}></div>
                                <div className="form-group">
                                    <button onClick={onClickToFinish} id="register-submit-btn" data-style="expand-left" className={`btn btn-primary w-100 ${loading ? 'spinner spinner-right disabled' : ''}`}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clear"></div>
        </div>}
    </>
}

export default CollabratorConfirmAccount;